/* Natural Roots — Bundle add-to-cart, anchor scrolling, and sticky CTA bar.
   Any link with href="#add-bundle" adds the bundle and opens the cart drawer.
   Any link with href="#shop-bundle" scrolls to the bundle section. */
(function () {
  var ANCHOR_ID = 'shop-bundle';

  function getBundleSection() {
    return document.querySelector('[data-section-type="nr-bundle"]') || document.querySelector('nr-bundle');
  }

  function headerOffset() {
    var header = document.querySelector('.m-header--sticky, .m-header, m-header, header');
    if (!header) return 20;
    var position = window.getComputedStyle(header).position;
    if (position === 'fixed' || position === 'sticky') {
      return header.getBoundingClientRect().height + 16;
    }
    return 20;
  }

  function scrollToBundle() {
    var target = getBundleSection();
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
    return true;
  }

  function placeAnchor() {
    if (document.getElementById(ANCHOR_ID)) return;
    var section = getBundleSection();
    if (!section) return;
    var anchor = document.createElement('span');
    anchor.id = ANCHOR_ID;
    anchor.setAttribute('aria-hidden', 'true');
    anchor.style.display = 'block';
    var host = section.closest('.shopify-section') || section;
    host.parentNode.insertBefore(anchor, host);
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var addTrigger = event.target.closest('a[href*="#add-bundle"]');
    if (addTrigger) {
      event.preventDefault();
      var widget = document.querySelector('nr-bundle');
      if (widget && typeof widget.addToCart === 'function') {
        widget.addToCart(addTrigger);
      } else {
        scrollToBundle();
      }
      return;
    }

    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    var hash = href.slice(hashIndex + 1);
    if (hash.indexOf('bundle') === -1) return;

    var path = href.slice(0, hashIndex);
    var samePage =
      path === '' ||
      path === window.location.pathname ||
      path === window.location.origin + window.location.pathname;
    if (!samePage) return;

    if (scrollToBundle()) {
      event.preventDefault();
      if (history.replaceState) history.replaceState(null, '', '#' + ANCHOR_ID);
    }
  });

  /* ---------------- Sticky CTA bar ---------------- */
  var stickyBar = null;
  var priceSources = null;
  var lifted = [];
  var state = { passedBundle: false, bundleVisible: false, footerVisible: false };

  function textOf(node, fallback) {
    return node && node.textContent.trim() ? node.textContent.trim() : fallback || '';
  }

  function collectFloatingWidgets() {
    var found = [];
    var candidates = document.querySelectorAll(
      '.m-back-to-top, .m-scroll-top, [class*="whatsapp" i], [id*="whatsapp" i], [class*="wa-widget" i]'
    );
    Array.prototype.forEach.call(candidates, function (el) {
      if (el === stickyBar || (stickyBar && stickyBar.contains(el))) return;
      if (window.getComputedStyle(el).position !== 'fixed') return;
      for (var i = 0; i < found.length; i++) {
        if (found[i].contains(el)) return;
      }
      found.push(el);
    });
    return found;
  }

  function liftWidgets(show) {
    if (!lifted.length) lifted = collectFloatingWidgets();
    var offset = show && stickyBar ? Math.round(stickyBar.getBoundingClientRect().height) + 12 : 0;

    lifted.forEach(function (el) {
      if (!el.hasAttribute('data-nr-base-bottom')) {
        var current = window.getComputedStyle(el).bottom;
        el.setAttribute('data-nr-base-bottom', current && current !== 'auto' ? current : '20px');
        el.style.transition = 'bottom .3s cubic-bezier(.22,.61,.36,1)';
      }
      var base = el.getAttribute('data-nr-base-bottom');
      el.style.bottom = show ? 'calc(' + base + ' + ' + offset + 'px)' : base;
    });
  }

  /* Currency apps rewrite prices AFTER load, so mirror the live nodes
     instead of freezing a copy of their text. */
  function syncStickyPrices() {
    if (!stickyBar || !priceSources) return;
    ['was', 'now', 'badge'].forEach(function (key) {
      var src = priceSources[key];
      var dest = priceSources['el_' + key];
      if (!src || !dest) return;
      var value = src.textContent.trim();
      if (value && dest.textContent.trim() !== value) dest.textContent = value;
    });
  }

  function watchPrices(scope) {
    if (!('MutationObserver' in window) || !scope) return;
    new MutationObserver(syncStickyPrices).observe(scope, {
      childList: true,
      subtree: true,
      characterData: true
    });
    [400, 1200, 2500, 4000].forEach(function (delay) {
      setTimeout(syncStickyPrices, delay);
    });
  }

  function renderSticky() {
    if (!stickyBar) return;
    var show = state.passedBundle && !state.bundleVisible && !state.footerVisible;
    stickyBar.classList.toggle('is-visible', show);
    document.body.classList.toggle('nr-sticky-active', show);
    liftWidgets(show);
    if (show) syncStickyPrices();
  }

  function observeSticky() {
    var section = getBundleSection();
    var footer = document.querySelector('#shopify-section-footer, .m-footer, footer');

    if (!('IntersectionObserver' in window)) {
      window.addEventListener('scroll', function () {
        state.passedBundle = window.pageYOffset > 900;
        renderSticky();
      });
      return;
    }

    if (section) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            state.bundleVisible = entry.isIntersecting;
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
              state.passedBundle = true;
            }
            renderSticky();
          });
        },
        { threshold: 0, rootMargin: '0px 0px -20% 0px' }
      ).observe(section);
    }

    if (footer) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            state.footerVisible = entry.isIntersecting;
            renderSticky();
          });
        },
        { threshold: 0 }
      ).observe(footer);
    }
  }

  function buildSticky() {
    liftWidgets(false);
    lifted = [];
    priceSources = null;

    var existing = document.querySelector('.nr-sticky');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    stickyBar = null;
    document.body.classList.remove('nr-sticky-active');

    var widget = document.querySelector('nr-bundle');
    if (!widget) return;

    var mainBtn = widget.querySelector('[data-nr-bundle-add]');
    if (!mainBtn || mainBtn.hasAttribute('disabled')) return;

    var section = widget.closest('[data-section-type="nr-bundle"]');
    var heading = section ? section.querySelector('.nr-bundle__heading') : null;
    var totals = widget.querySelector('.nr-bundle__totals');
    var nowPrice = widget.querySelector('.nr-bundle__total-row--final span:last-child');
    var wasPrice = widget.querySelector('.nr-bundle__total-row--was span:last-child');
    var badge = widget.querySelector('.nr-bundle__badge');
    var btnLabel = mainBtn.querySelector('span');

    var bar = document.createElement('div');
    bar.className = 'nr-sticky';

    var inner = document.createElement('div');
    inner.className = 'nr-sticky__inner';

    var info = document.createElement('div');
    info.className = 'nr-sticky__info';

    var title = document.createElement('span');
    title.className = 'nr-sticky__title';
    title.textContent = textOf(heading, '');
    if (title.textContent) info.appendChild(title);

    var prices = document.createElement('span');
    prices.className = 'nr-sticky__prices';

    priceSources = { was: wasPrice, now: nowPrice, badge: badge };

    if (wasPrice) {
      var was = document.createElement('span');
      was.className = 'nr-sticky__was';
      was.textContent = textOf(wasPrice, '');
      prices.appendChild(was);
      priceSources.el_was = was;
    }
    if (nowPrice) {
      var now = document.createElement('span');
      now.className = 'nr-sticky__now';
      now.textContent = textOf(nowPrice, '');
      prices.appendChild(now);
      priceSources.el_now = now;
    }
    if (badge) {
      var badgeEl = document.createElement('span');
      badgeEl.className = 'nr-sticky__badge';
      badgeEl.textContent = textOf(badge, '');
      prices.appendChild(badgeEl);
      priceSources.el_badge = badgeEl;
    }
    if (prices.childNodes.length) info.appendChild(prices);
    if (info.childNodes.length) inner.appendChild(info);

    var cta = document.createElement('a');
    cta.className = 'nr-sticky__cta m-button m-button--primary';
    cta.href = '#add-bundle';
    cta.textContent = textOf(btnLabel, 'أضيفي الباقة إلى السلة');
    inner.appendChild(cta);

    bar.appendChild(inner);
    document.body.appendChild(bar);
    stickyBar = bar;

    watchPrices(totals || widget);
    observeSticky();
    renderSticky();
  }

  function init() {
    placeAnchor();
    buildSticky();
    if (window.location.hash && window.location.hash.indexOf('bundle') !== -1) {
      setTimeout(scrollToBundle, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    setTimeout(function () {
      lifted = [];
      syncStickyPrices();
      renderSticky();
    }, 1500);
  });

  document.addEventListener('shopify:section:load', function () {
    state = { passedBundle: false, bundleVisible: false, footerVisible: false };
    setTimeout(init, 100);
  });
})();

if (!customElements.get('nr-bundle')) {
  class NRBundle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-nr-bundle-add]');
      this.errorWrapper = this.querySelector('[data-nr-bundle-error]');
      if (this.button) {
        this._onClick = this.onAdd.bind(this);
        this.button.addEventListener('click', this._onClick);
      }
    }

    disconnectedCallback() {
      if (this.button && this._onClick) this.button.removeEventListener('click', this._onClick);
    }

    onAdd(event) {
      event.preventDefault();
      this.addToCart(this.button);
    }

    /* Adds the bundle and opens Minimog's side cart drawer.
       Deliberately independent of the `use_ajax_atc` / `enable_cart_drawer`
       theme settings: those are absent from settings_data.json, so relying on
       them silently fell through to a cart-page redirect. The shopper must
       always stay on the landing page. */
    addToCart(trigger) {
      if (!this.button) return;
      if (this.button.hasAttribute('disabled')) return;

      const variantId = this.button.dataset.variantId;
      if (!variantId) return;

      const quantity = parseInt(this.button.dataset.quantity || '1', 10) || 1;
      const settings = window.MinimogSettings || {};
      const strings = window.MinimogStrings || {};
      const theme = window.MinimogTheme || {};

      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );

      let config;
      if (typeof fetchConfig === 'function') {
        config = fetchConfig('javascript');
      } else {
        config = { headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
      }
      config.method = 'POST';
      config.body = JSON.stringify({
        items: [{ id: variantId, quantity: quantity }],
        sections: sections,
        sections_url: window.location.pathname
      });

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const addUrl = (settings.routes && settings.routes.cart_add_url) || root + 'cart/add.js';

      this.toggleLoading(true, trigger);

      fetch(addUrl, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message || 'تعذّرت الإضافة إلى السلة. حاولي مرة أخرى.');
            document.dispatchEvent(
              new CustomEvent('product-ajax:error', { detail: { errorMessage: response.description } })
            );
            return;
          }

          // Tell the theme the cart changed so the drawer re-renders with the new line
          if (window.MinimogEvents && theme.pubSubEvents) {
            window.MinimogEvents.emit(theme.pubSubEvents.cartUpdate, { cart: response });
          }
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: response } }));

          this.openDrawer(strings, theme);
        })
        .catch((error) => {
          console.error('nr-bundle: add to cart failed', error);
          this.showError('حدث خطأ أثناء الإضافة إلى السلة. حاولي مرة أخرى.');
        })
        .finally(() => {
          this.toggleLoading(false, trigger);
        });
    }

    /* The drawer element sometimes upgrades a moment after the theme boots,
       so retry briefly before falling back to a toast. Never redirect. */
    openDrawer(strings, theme, attempt) {
      attempt = attempt || 0;
      const drawer = document.querySelector('m-cart-drawer');

      if (drawer && typeof drawer.open === 'function') {
        if (theme.Notification) {
          const target = drawer.querySelector('m-cart-items');
          if (target) {
            theme.Notification.show({
              target: target,
              method: 'prepend',
              type: 'success',
              message: strings.itemAdded || 'تمت الإضافة إلى السلة',
              delay: 400
            });
          }
        }
        drawer.open();
        return;
      }

      if (attempt < 10) {
        setTimeout(() => this.openDrawer(strings, theme, attempt + 1), 150);
        return;
      }

      if (theme.Notification) {
        theme.Notification.show({
          target: this.errorWrapper || document.body,
          method: 'appendChild',
          type: 'success',
          message: strings.itemAdded || 'تمت الإضافة إلى السلة',
          last: 3000,
          sticky: !this.errorWrapper
        });
      }
    }

    showError(message) {
      const theme = window.MinimogTheme || {};
      if (theme.Notification && this.errorWrapper) {
        theme.Notification.show({
          target: this.errorWrapper,
          method: 'appendChild',
          type: 'warning',
          message: message
        });
      } else if (this.errorWrapper) {
        this.errorWrapper.textContent = message;
      }
    }

    toggleLoading(loading, trigger) {
      if (this.button) {
        this.button.classList[loading ? 'add' : 'remove']('m-spinner-loading');
        if (loading) {
          this.button.setAttribute('aria-busy', 'true');
        } else {
          this.button.removeAttribute('aria-busy');
        }
      }
      if (trigger && trigger !== this.button) {
        trigger.classList[loading ? 'add' : 'remove']('nr-is-loading');
      }
    }
  }
  customElements.define('nr-bundle', NRBundle);
}